export const fillCompanyId = ({ route, companyId }) =>
  route.replace(':companyId', companyId);

export default { fillCompanyId };
